import React from 'react';
import authRoles from '../../../auth/authRoles';
import AdminDetail from '@/app/fuse-layouts/shared-components/adminDetail';
import Editprofile from '@/app/fuse-layouts/shared-components/Editprofile';

const SuperAdminProfileConfig = {
	settings: {
		layout: {
			Config: {},
		},
	},
	routes: [
		{
			path: '/superadminprofile',
			// component: adminDetail,
			element: (
				<React.Suspense fallback={<>...</>}>
					<AdminDetail />
				</React.Suspense>
			),
		},
		{
			path: '/Editprofile',
			// component: Editprofile,
			element: (
				<React.Suspense fallback={<>...</>}>
					<Editprofile />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.admin,
};

export default SuperAdminProfileConfig;
